<template>
  <a
    :href="url"
    :title="name"
    target="_blank"
  >
    <div class="flex items-center text-gray-500 ">
      <div class="w-9 mr-3">
        <img :src="src" :title="name + ' logo'" :alt="name + ' logo'">
      </div>
      <div
        class="ftr-review-score ota-small-light inline md:flex md:w-auto"
        itemprop="aggregateRating"
        itemscope
        itemtype="http://schema.org/AggregateRating"
      >
        <div class="inline">
          <span v-t="'Footer.CustomerReview'" />:
          <meta itemprop="worstRating" content="1">
          <span class="ota-small" itemprop="ratingValue" v-text="rating" /> /
          <span v-text="maxRating" />
          <span class="hidden md:inline">&nbsp;-&nbsp;</span>
        </div>
        <br>
        <div class="inline">
          <span v-text="amountReviews" />
          <span v-t="'Footer.Reviews'" />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'AggregateRating',
  props: {
    url: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    rating: {
      type: String,
      default: ''
    },
    maxRating: {
      type: String,
      default: ''
    },
    amountReviews: {
      type: Number,
      default: 0
    }
  }
}
</script>
